import type { LocationQueryValue } from 'vue-router';

/**
 * Narrow a `route.query` entry to a single string.
 *
 * Vue Router types query entries as `string | null | (string | null)[]` — `null` for a valueless
 * `?flag`, an array for a repeated key. Returns `undefined` for anything that isn't a lone string
 * so callers can fall through with `??`.
 */
export function queryString(
  value: LocationQueryValue | LocationQueryValue[] | undefined,
): string | undefined {
  return typeof value === 'string' ? value : undefined;
}

// Narrow a `route.query` entry to a path safe to navigate to, rejecting anything that would leave the site
export function internalPath(
  value: LocationQueryValue | LocationQueryValue[] | undefined,
): string | undefined {
  const path = queryString(value);

  if (!path?.startsWith('/') || path.startsWith('//') || path.startsWith('/\\')) {
    return undefined;
  }

  return path;
}
